
<template>
    <v-flex xs12 md5 lg4>
      <v-form ref="loginForm">
        <v-layout row wrap class="login-box px-3 py-3">
          <v-alert v-model="alert.status" dismissible :type="alert.type" class="mb-3">{{ alert.message }}</v-alert>
          <v-flex xs12>
            <v-text-field v-model="loginData.document" label="CPF. (APENAS NUMEROS)" :rules="documentRules" :counter="11" required box />
          </v-flex>
          <v-flex xs12>
            <v-text-field v-model="loginData.password" :rules="passwordRules" type="password" label="SENHA" @keyup.enter="login()" required box />
          </v-flex>
          <v-flex xs12>
            <v-btn class="ma-0 pa-0" @click="login()" outline>ACESSAR</v-btn>
          </v-flex>
        </v-layout>
      </v-form>
    </v-flex>
</template>

<script>
import axios from 'axios'
export default {
  name: 'dashboard',
  data() {
    return {
      loginData: {
        document: '',
        password: ''
      },
      documentRules: [
        v => !!v || 'CPF REQUERIDO!',
        v => (v && v.length == 11) || 'CPF DEVE CONTER EXATAMENTE 11 DIGITOS!'
      ],
      passwordRules: [
        v => !!v || 'SENHA REQUERIDA!',
        v => (v && v.length >= 6) || 'SENHA NÃO PODE TER MENOS DE 6 CARACTERES!'
      ],
      alert: {
        message: 'USUÁRIO OU SENHA INCORRETOS! TENTE NOVAMENTE...',
        type: 'error',
        status: false
      }
    }
  },
  methods: {
    login() {
      if (this.$refs.loginForm.validate()) {
        this.alert.status = false
        this.$http.post('users/login', this.loginData).then(data => {
          localStorage.setItem('miolocat', data.data.token)
          axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.miolocat}`
          this.$store.commit('userData', data.data.user)
          this.$store.commit('login', false)
          this.$router.push({name: 'dashboard'})
        }).catch(err => {
          this.alert.status = true
        })
      }
    }
  },
  beforeCreate() {
    // OCULTA O MENU DE NAVEGAÇÃO, BARRA E RODAPÉ. //
    this.$store.commit('login', true)
    // CASO ESTEJA LOGADO, REMOVE AS CREDENCIAIS PARA UM NOVO LOGIN! //
    if (localStorage.miolocat) {
      localStorage.removeItem('miolocat')
    }
  }
}
</script>

<style scoped>
  .login-box {
    background-color: rgba(255,255,255,.8);
    border-radius: 10px;
  }
</style>
